"use client";

import React from "react";

import { SectionTitle } from "./section-title";
import { SkeletonBox } from "./skeleton-box";

export const ProjectPanelSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 px-3 py-4">
      <div>
        <SectionTitle title="Basic Info" />
        <div className="mt-2 flex flex-col gap-3 py-1">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="flex h-4 gap-2"
            >
              <SkeletonBox className="h-4 w-24 shrink-0" />
              <SkeletonBox className="h-4 flex-1" />
            </div>
          ))}
        </div>
      </div>
      <div>
        <SectionTitle title="Scheduled Occupancy" />
        <div className="mt-2 flex flex-col gap-3 py-1">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="flex h-4 gap-2"
            >
              <SkeletonBox className="h-4 w-16 shrink-0" />
              <SkeletonBox className="h-4 flex-1" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
